export default {
      id: "icon--arrow-down-usage",
      viewBox: "0 0 10 7",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--arrow-down-usage",
      toString: function () {
        return this.url;
      }
    }